export const VCS_PARENTS: any[] = [{
  "branch" : "heads/refs/tags/SASHA3.29.17",
  "date" : ["1709655414"],
  "node" : "7887793a82d40ac8539733b8f01bcb7ea4d2d6cb",
  "tags" : ["SASHA3.29.17"]
}];